function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
export var ClickableHoverableWrapper = function ClickableHoverableWrapper(_ref) {
  var onClick = _ref.onClick,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut,
      children = _ref.children;
  return React.Children.map(children, function (child) {
    var style = _objectSpread(_objectSpread({}, child.props.style), {}, {
      display: 'inline-flex',
      cursor: onClick ? 'pointer' : undefined
    });

    return /*#__PURE__*/React.createElement("div", {
      onClick: onClick,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      style: style
    }, children);
  });
};